import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import MyselfForm from './MyselfForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import trackUserData from 'react/signups/card/common/MarketoTracker';
import WizardCard from 'react/signups/card/common/WizardCard';
import profileDataShape from 'react/signups/card/shapes/ProfileData';

export default function MyselfProfile({ moduleComplete, profileData, setProfileData }) {
  const validationSchema = Yup.object().shape({
    address: schema.address.required(),
    firstName: schema.firstName.required(),
    lastName: schema.lastName.required(),
    mobile: schema.mobile.required(),
    referralCategory: schema.referralCategory,
    referralCategoryDetail: schema.referralCategoryDetail,
    referralName: schema.referralName,
    countryOfCitizenship: schema.countryOfCitizenship.required(),
    nonResidentAlien: Yup.string().when(['countryOfCitizenship'], {
      is: (countryOfCitizenship) => countryOfCitizenship !== 'US',
      then: () => schema.nonResidentAlien.required(),
      otherwise: () => schema.nonResidentAlien.nullable(),
    }),
  });

  const handleContinue = (values) => {
    trackUserData({
      FirstName: values.firstName,
      LastName: values.lastName,
      Phone: values.mobile,
      Company: `${values.firstName} ${values.lastName}`,
      Referree_Code__c: values.referralName,
    });
    setProfileData({
      address: values.address,
      firstName: values.firstName,
      lastName: values.lastName,
      mobile: values.mobile,
      referralCategory: values.referralCategory,
      referralCategoryDetail: values.referralCategoryDetail,
      referralName: values.referralName,
      countryOfCitizenship: values.countryOfCitizenship || '',
      nonResidentAlien: values.nonResidentAlien || '',
    });
  };

  return (
    <WizardCard showBackButton={false}>
      <CardHeader>{'Tell us a little more about you'}</CardHeader>
      <Formik
        initialValues={profileData}
        onSubmit={handleContinue}
        validationSchema={validationSchema}
      >
        {({ handleChange, handleSubmit, setFieldTouched, setValues, setFieldValue, values }) => (
          <>
            <MyselfForm
              onChange={handleChange}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              setValues={setValues}
              values={values}
            />
            <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
          </>
        )}
      </Formik>
    </WizardCard>
  );
}

MyselfProfile.propTypes = {
  moduleComplete: PropTypes.bool.isRequired,
  profileData: profileDataShape.isRequired,
  setProfileData: PropTypes.func.isRequired,
};
